require('./angular-busy');
module.exports = 'cgBusy';


//////////////////
// WEBPACK FOOTER
// ./~/angular-busy/dist/index.js
// module id = 436
// module chunks = 36